var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShowPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C14.5 13.3827 13.3827 14.5 12 14.5C10.6173 14.5 9.5 13.3827 9.5 12C9.5 10.6173 10.6173 9.5 12 9.5C13.3827 9.5 14.5 10.6173 14.5 12Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.5C15.2468 18.5 18.2729 16.8662 20.3792 14.0384C21.207 12.9308 21.207 11.0692 20.3792 9.96163C18.2729 7.13384 15.2468 5.5 12 5.5C8.75319 5.5 5.72713 7.13384 3.62085 9.96163C2.79305 11.0692 2.79305 12.9308 3.62085 14.0384C5.72713 16.8662 8.75319 18.5 12 18.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPassword);
export default __webpack_public_path__ + "static/media/show-password.cf98559bf6f96f009d91523830f3e758.svg";
export { ForwardRef as ReactComponent };